module.exports = __webpack_public_path__ + "static/media/plasticart_clientLogo.d8a01810.png";